export function useVibrate() {
  return {
    vibrate: async (pattern: number) => {
      if (navigator.vibrate) {
        navigator.vibrate(pattern)
      }
    }
  }
}
